import type { TFunction } from 'i18next';
import { SignupRequestError } from './signup-api/signup-api';

/**
 * The page message for a failed code send: the server's wait on a rate limit,
 * otherwise the generic retry message.
 */
export function sendFailureStatus(t: TFunction, error: unknown): string {
  if (
    error instanceof SignupRequestError &&
    error.code === 'otp_rate_limited' &&
    error.retryAfterSeconds !== undefined
  ) {
    return t('account.rateLimited', { count: error.retryAfterSeconds });
  }
  return t('account.genericError');
}
